<template>
    <div id="Financial_Top">
        <div>
            <div>
                <!--        面包屑-->
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item>结算记录</el-breadcrumb-item>
                </el-breadcrumb>
                <el-card>
                    <div class="financial_head">
                        <div class="head-item">
                            <h5>未提现</h5>
                            <p><span>￥{{headData.money}}</span>
                                <el-button type="primary" size="small" @click="apply">一键提现</el-button>
                            </p>
                        </div>
                        <div class="head-item">
                            <h5>提现中</h5>
                            <p>￥{{headData.wait_withdraw_money}}</p>
                        </div>
                        <div class="head-item">
                            <h5>累计打款</h5>
                            <p>￥{{headData.already_withdraw_money}}</p>
                        </div>
                    </div>
                </el-card>
                <el-card>
                    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                        <el-tab-pane label="提现中" name="first">
                            <withdrawImg v-if="activeName=='first'"></withdrawImg>
                        </el-tab-pane>
                        <el-tab-pane label="已提现" name="second">
                            <withdrawed v-if="activeName=='second'"></withdrawed>
                        </el-tab-pane>
                    </el-tabs>
                </el-card>
            </div>
        </div>
    </div>
</template>

<script>
    import withdrawImg from '../../components/financial_withdraw/withdrawImg'
    import withdrawed from '../../components/financial_withdraw/withdrawed'

    export default {
        name: "Financial_Top",
        components: {withdrawImg, withdrawed},
        data() {
            return {
                activeName: 'first',
                headData: {
                    already_withdraw_money: '',
                    wait_withdraw_money: ''
                }
            }
        },
        created() {
            this.$axios.post("mch/withdraw/index").then((res) => {
                console.log(res.data);
                this.headData = res.data;
            });
        },
        methods: {
            handleClick(tab, event) {
                this.activeName = tab.name;
            },
            apply() {
                this.$confirm('是否进行该操作, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.post("mch/withdraw/apply").then((res) => {
                        this.$message({
                            type: 'success',
                            message: '操作成功!'
                        });
                    });

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                })
            }
        }
    }
</script>

<style scoped>
    @media screen and (max-width: 750px) {
        .financial_head {
            flex-wrap: wrap;
        }

        .financial_head .head-item {
            width: 100%;
            margin-bottom: 20px;
        }
    }

    .financial_head {
        display: flex;
        justify-content: space-between;
    }

    .head-item {
        width: 32%;
        background: #F5F5F5;
        padding: 10px 20px;
        border-radius: 8px;
        box-sizing: border-box;
    }

    .head-item h5 {
        color: #2c8fed;
        font-size: 18px;
        line-height: 30px;
    }

    .head-item p {
        font-weight: 700;
        line-height: 50px;
        font-size: 26px;
        display: flex;
        align-items: center;
    }

    .head-item p span {
        margin-right: 30px;
    }
</style>